import {
  CABECA,
  CAIXA_COMPACTA,
  CAIXA_SIMBOLO,
  CRINA,
  EQUI,
  NOME_NA_COMPACTA,
  SIMBOLO_NA_COMPACTA,
  VIEW,
} from './marca-desenho.js';

/**
 * Cores da marca (Identidade visual 2.0). A cor principal e `currentColor`; a
 * de destaque (crina e "view") vem de `--marca-destaque`.
 *   tema   — segue o claro/escuro do app (Abismo + Aco / Gelo + Nevoa)
 *   claro  — sobre fundo claro, fixo
 *   escuro — sobre fundo escuro, fixo (topo Abismo, painel do login)
 *   mono   — uma cor so, a do texto em volta (placeholder, impressao)
 */
export type TomMarca = 'tema' | 'claro' | 'escuro' | 'mono';

const TONS: Record<TomMarca, string> = {
  tema: 'text-logo [--marca-destaque:var(--color-logo-destaque)]',
  claro: 'text-abismo [--marca-destaque:var(--color-aco)]',
  escuro: 'text-gelo [--marca-destaque:var(--color-nevoa)]',
  mono: '[--marca-destaque:currentColor]',
};

function DesenhoSimbolo() {
  return (
    <>
      <g fill="currentColor">
        {CABECA.map((d) => (
          <path key={d.slice(0, 24)} d={d} />
        ))}
      </g>
      <path fill="var(--marca-destaque)" d={CRINA} />
    </>
  );
}

/** Simbolo isolado (cabeca + crina). Largo: ~1,75:1 — defina a altura ou a largura. */
export function Simbolo({ tom = 'tema', className = 'h-8' }: { tom?: TomMarca; className?: string }) {
  return (
    <svg viewBox={CAIXA_SIMBOLO} aria-hidden className={`w-auto shrink-0 ${TONS[tom]} ${className}`}>
      <DesenhoSimbolo />
    </svg>
  );
}

/*
  Tagline da assinatura principal. Nao veio SVG da horizontal, entao ela e
  composta aqui: mesma largura do nome (textLength), caixa-alta espacada.
*/
const TAGLINE = 'AVALIAÇÃO MORFOFUNCIONAL EQUINA';
const NOME_X = 198;
const NOME_LARGURA = 365;

/**
 * Logotipo. Sem `tagline` e a assinatura compacta (topo, formularios); com
 * `tagline`, a principal horizontal (login). Area de respiro do guia: deixe
 * livre em volta, no minimo, metade da altura da compacta — quem posiciona e
 * o container.
 */
export function Marca({
  tom = 'escuro',
  tagline = false,
  className = 'h-7',
}: {
  tom?: TomMarca;
  tagline?: boolean;
  className?: string;
}) {
  const [, , largura, altura] = CAIXA_COMPACTA.split(' ').map(Number) as [number, number, number, number];
  return (
    <svg
      viewBox={`0 0 ${largura} ${tagline ? altura + 26 : altura}`}
      role="img"
      aria-label="Equiview"
      className={`w-auto shrink-0 ${TONS[tom]} ${className}`}
    >
      <g transform={SIMBOLO_NA_COMPACTA}>
        <DesenhoSimbolo />
      </g>
      <g transform={NOME_NA_COMPACTA}>
        <g fill="currentColor">
          {EQUI.map((d) => (
            <path key={d.slice(0, 24)} d={d} />
          ))}
        </g>
        <g fill="var(--marca-destaque)">
          {VIEW.map((d) => (
            <path key={d.slice(0, 24)} d={d} />
          ))}
        </g>
      </g>
      {tagline && (
        <text
          x={NOME_X}
          y={altura + 16}
          textLength={NOME_LARGURA}
          lengthAdjust="spacing"
          fill="currentColor"
          opacity={0.75}
          className="font-sans"
          style={{ fontSize: 12.5, fontWeight: 600 }}
        >
          {TAGLINE}
        </text>
      )}
    </svg>
  );
}
